import { useAuth } from "../auth/AuthProvider";

export function LoginButton() {
  const { login } = useAuth();
  return (
    <button className="google-login" onClick={() => void login()}>
      Sign in with Google
    </button>
  );
}
